import { get } from 'lodash/fp';

import getPlayersFromGames from '../utils/getPlayersFromGames';
import { getTeams, normalizeTeamPosition } from './decodeChallenge';

const decodePlayerPool = (data = {}) => {
  const teamPosition = normalizeTeamPosition(get('rule_set.selection_rules', data));

  return { ...getPlayersFromGames(data.games), ...getTeams(data.games, teamPosition) };
};

export default decodePlayerPool;
